<template>
  <div class="ch_weday">
    <div class="left">
      <a
        @click="searchChkDate('Y')"
        :class="{ act: $store.state.usRecordSettings.chkDate == 'Y' }"
        class="day"
        >어제</a
      >
      <a
        @click="searchChkDate('D')"
        :class="{ act: $store.state.usRecordSettings.chkDate == 'D' }"
        class="day"
        >오늘</a
      >
      <a
        @click="searchChkDate('T')"
        :class="{ act: $store.state.usRecordSettings.chkDate == 'T' }"
        class="day"
        >내일</a
      >
      <a
        @click="searchChkDate('P')"
        :class="{ act: $store.state.usRecordSettings.chkDate == 'P' }"
        class="week ml_10"
        >이번주</a
      >
      <a
        @click="searchChkDate('N')"
        :class="{ act: $store.state.usRecordSettings.chkDate == 'N' }"
        class="week"
        >다음주</a
      >
    </div>
    <!-- //left -->
    <div class="right">
      <dl>
        <dt>기간</dt>
        <dd>
          <input
            type="text"
            id="chkSDate"
            name="chkSDate"
            :value="searchPage.chkSDate"
            placeholder="시작일"
            readonly
          />
          &nbsp;~&nbsp;
          <input
            type="text"
            id="chkEDate"
            name="chkEDate"
            :value="searchPage.chkEDate"
            placeholder="종료일"
            readonly
          />
          <button @click="searchChkDate('S')">조회</button>
        </dd>
      </dl>
    </div>
    <!-- //right -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      searchPage: {
        chkSDate: null,
        chkEDate: null
      }
    }
  },
  methods: {
    getFormatDate (gb) {
      let date = new Date()
      let year = date.getFullYear()
      let month = (1 + date.getMonth())
      let day
      month = month >= 10 ? month : '0' + month
      if (gb === 'sdate') {
        day = '01'
      } else {
        day = date.getDate()
        day = day >= 10 ? day : '0' + day
      }
      return year + '' + month + '' + day
    },
    User (chkDate) {
      this.$store.dispatch('saveUsChkDateSetting', chkDate)
      this.searchPage.chkSDate = $('#chkSDate').val()
      this.searchPage.chkEDate = $('#chkEDate').val()
      this.$emit('setDateSearh', this.searchPage)
    },
    searchChkDate (chkDate) {
      this.$store.dispatch('saveUsChkDateSetting', chkDate)
    }
  },
  computed: {
    ...mapGetters(['getUsRecordSettings']),
    getChkDate () {
      return this.getUsRecordSettings.chkDate
    }
  },
  created () {
    this.searchPage.chkSDate = this.getFormatDate('sdate')
    this.searchPage.chkEDate = this.getFormatDate('edate')
  },
  mounted () {
    $('#chkSDate').datepicker({
      changeMonth: true,
      changeYear: true,
      showMonthAfterYear: true,
      dateFormat: 'yymmdd',
      dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
      monthNamesShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
      showOtherMonths: true,
      selectOtherMonths: true
    })

    $('#chkEDate').datepicker({
      changeMonth: true,
      changeYear: true,
      showMonthAfterYear: true,
      dateFormat: 'yymmdd',
      dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
      monthNamesShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
      showOtherMonths: true,
      selectOtherMonths: true
    })
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/kiwoom/usRecord/pc/common/DateSearch.vue